import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d1a030a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "content" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination" }, null, -1))
const _hoisted_6 = { class: "prev-next" }
const _hoisted_7 = { class: "information-bar" }
const _hoisted_8 = { class: "info-title" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "新闻", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "公告", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "活动", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "date" }
const _hoisted_19 = { class: "news-title" }
const _hoisted_20 = { class: "news-brief" }

import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation, Autoplay } from "swiper";
import { useRouter } from "vue-router";
import { useHomeNews, useHomeNewsSwiper } from "@/api/indexPC";
import dayjs from "dayjs";
import { GlobalState } from "@/pages/index/store";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore<GlobalState>();
const router = useRouter();

let pagination = {
  el: ".swiper-pagination",
  clickable: true,
};
let navigation = {
  nextEl: ".home-info .swiper-button-next",
  prevEl: ".home-info .swiper-button-prev",
};
let modules = [Pagination, Navigation, Autoplay];

function slideChange(e: any) {
  // 当前 index.scss
  // console.log(e.realIndex);
}

function gotoArticleDetails(id: number) {
  router.push({
    path: `/articleDetails/${id}`,
  });
}
// 首页资讯
let { data: infoList } = useHomeNews();
// 首页图片资讯
let { data: infoListSwiper } = useHomeNewsSwiper();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "home-info",
    id: "home_info",
    style: _normalizeStyle({
      backgroundImage: 'url(' + _unref(store)?.state?.imageObj?.backg?.new?.pc + ')',
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _unref(store)?.state?.imageObj?.title?.new?.pc,
        alt: "唐画资讯"
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "swiper-box",
        style: _normalizeStyle({
          backgroundImage:
            'url(' + _unref(store)?.state?.imageObj?.border?.newtop?.pc + ')',
        })
      }, [
        _createVNode(_unref(Swiper), {
          navigation: _unref(navigation),
          pagination: _unref(pagination),
          modules: _unref(modules),
          class: "mySwiper",
          loop: "",
          autoplay: {
            delay: 3500,
            disableOnInteraction: false,
          },
          onSlideChange: _cache[0] || (_cache[0] = ($event: any) => (slideChange($event)))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(infoListSwiper)?.data.data, (item) => {
              return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                key: item.id,
                onClick: ($event: any) => (gotoArticleDetails(item.id))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: item?.img,
                    alt: ""
                  }, null, 8, _hoisted_4)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["navigation", "pagination", "modules"]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "swiper-button-prev",
            style: _normalizeStyle({
              backgroundImage:
                'url(' + _unref(store)?.state?.imageObj?.ico?.newtop?.l?.pc + ')',
            })
          }, null, 4),
          _createElementVNode("div", {
            class: "swiper-button-next",
            style: _normalizeStyle({
              backgroundImage:
                'url(' + _unref(store)?.state?.imageObj?.ico?.newtop?.r?.pc + ')',
            })
          }, null, 4)
        ])
      ], 4),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: "info-title-item",
            style: _normalizeStyle({
              backgroundImage:
                'url(' + _unref(store)?.state?.imageObj?.backg?.ico?.new + ')',
            }),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push({ name: 'news' })))
          }, _hoisted_10, 4),
          _createElementVNode("div", {
            class: "info-title-item",
            style: _normalizeStyle({
              backgroundImage:
                'url(' + _unref(store)?.state?.imageObj?.backg?.ico?.new + ')',
            }),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push({ name: 'notice' })))
          }, _hoisted_12, 4),
          _createElementVNode("div", {
            class: "info-title-item",
            style: _normalizeStyle({
              backgroundImage:
                'url(' + _unref(store)?.state?.imageObj?.backg?.ico?.new + ')',
            }),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push({ name: 'activity' })))
          }, _hoisted_14, 4),
          _createElementVNode("div", {
            class: "info-title-item",
            style: _normalizeStyle({
              backgroundImage:
                'url(' + _unref(store)?.state?.imageObj?.backg?.ico?.more + ')',
            }),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).push({ name: 'more' })))
          }, _hoisted_16, 4)
        ]),
        _createElementVNode("div", {
          class: "info-content",
          style: _normalizeStyle({
            backgroundImage:
              'url(' + _unref(store)?.state?.imageObj?.border?.newouter?.pc + ')',
          })
        }, [
          _createElementVNode("div", {
            class: "info-content-box",
            style: _normalizeStyle({
              backgroundImage:
                'url(' + _unref(store)?.state?.imageObj?.border?.newwithin?.pc + ')',
            })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(infoList)?.data.data, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "info-content-item",
                key: item.id,
                onClick: ($event: any) => (gotoArticleDetails(item.id))
              }, [
                _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(dayjs).unix(item.time).format("YYYY.MM.DD")), 1),
                _createElementVNode("div", _hoisted_19, _toDisplayString(item.type_name) + " | " + _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_20, _toDisplayString(item.note), 1)
              ], 8, _hoisted_17))
            }), 128))
          ], 4)
        ], 4)
      ])
    ])
  ], 4))
}
}

})